import { createTheme } from "@mui/material";

import { defaultTheme } from "./defaultThemeOptions";

const theme = createTheme(defaultTheme);

export default theme;
